import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type InitialState = {
  notificationIds: string[];
};

const initialState: InitialState = {
  notificationIds: [],
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationIds: (state, action: PayloadAction<string>) => {
      state.notificationIds = [...state.notificationIds, action.payload];
    },
    clearNotificationIds: (state) => {
      state.notificationIds = [];
    },
  },
});

export const { setNotificationIds, clearNotificationIds } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
